import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { MedicalReportDetailsComponent } from "./medical-report-details/medical-report-details.component";
import { MedicalReportRoutingModule } from "./medical-report-routing.module";
import { TcmCommonSharedModule } from "../../modules/tcm-common/tcm-common.shared.module";
import { TCMCoreModule } from "../../modules/tcm-core.module/tcm-core.module";
import { TCMFormModule } from "../../modules/tcm-form/tcm-form.module";
import { WidgetsModule } from "../../modules/widgets/widgets.module";


const components = [
    MedicalReportDetailsComponent
]

@NgModule({
    declarations: [
        components,
    ],
    imports: [
        CommonModule,
        FormsModule,
        TCMCoreModule,
        TCMFormModule,
        TranslateModule,
        TcmCommonSharedModule,
        WidgetsModule,
        MedicalReportRoutingModule
    ],
    exports: [
        components
    ],
    providers: [
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class MedicalReportModule { }
